import {
  ActionFunctionArgs,
  json,
  LoaderFunctionArgs,
  redirect,
} from "@remix-run/node";
import { Form, useActionData } from "@remix-run/react";
import { useEffect, useState } from "react";
import { ButtonBasic } from "~/components/design/ButtonBasic";
import { getGraphqlContactAuthUrl } from "~/gql/url_helpers";
import { useRootContext } from "~/root_context";
import mySvgHref from "../components/layout_mira_clone/logo.svg";

import { createContactSession, getContactId } from "~/session.server";
import {
  AFTER_LOGIN_URL,
  FORGOT_PASSWORD_URL,
  LOGIN_URL,
} from "~/known_routes";

export async function loader({ request }: LoaderFunctionArgs) {
  const contactId = await getContactId(request);
  if (contactId) return redirect(AFTER_LOGIN_URL);
  return json({});
}

export async function action({ request }: ActionFunctionArgs) {
  const formData = await request.formData();
  const email = formData.get("email");
  const password = formData.get("password");

  if (!email || !password) {
    return redirect(LOGIN_URL);
  }

  // Perform form validation
  // For example, check the email is a valid email
  // Return the errors if there are any

  // const user = await verifyLogin(email, password);
  const fd = new URLSearchParams();
  fd.append("username", (email as string).trim());
  fd.append("password", (password as string).trim());

  const verify = await fetch(getGraphqlContactAuthUrl(), {
    method: "POST",
    body: fd,
  });
  console.log("verify", verify);
  // const user = { id: "1" };
  if (!verify.ok) {
    return json({ success: false, reason: "Invalid login, please try again." });
  }
  const verifyResults = await verify.json();
  console.log("verifyResults", verifyResults);
  if (
    verifyResults["contact"]["contactType"] !== "PM Administrator" &&
    verifyResults["contact"]["contactType"] !== "CPR Admin"
  ) {
    return json({
      success: false,
      reason: `You do not have permission to access this portal (role = ${JSON.stringify(
        verifyResults["contact"]["contactType"]
      )}).`,
    });
  }
  return createContactSession({
    request,
    contactId: verifyResults["contact"]["id"],
    graphToken: verifyResults["access_token"],
    role: verifyResults["contact"]["contactType"],
    email: (email as string).trim(),
    fullName: verifyResults["contact"]["fullName"],
  });
}

export default function LoginPage() {
  const { setBodyStyles } = useRootContext();
  const actionData = useActionData<{ success?: boolean; reason?: string }>();
  const [showError, setShowError] = useState<boolean>(
    actionData?.success === false
  );

  useEffect(() => {
    setBodyStyles("h-full");
    return () => {
      setBodyStyles("");
    };
  }, []);

  useEffect(() => {
    if (actionData?.success === false) {
      setShowError(true);
    }
  }, [actionData]);

  return (
    <div className="flex h-full">
      <div className="flex-1 bg-blue-700 h-full">
        <div className="flex flex-col items-center justify-center h-full">
          <div className="bg-white">
            <div className="text-5xl font-bold text-center mt-10 flex justify-center">
              <img src={mySvgHref} className="w-12 h-12 mr-2" />
              CPRM
            </div>
            <div className="text-2xl m-5 text-center">Admin Portal</div>

            <div>
              <Form method="post" className="flex flex-col m-10 min-w-[300px]">
                <div id="form-error-message" className="mb-2">
                  {showError && actionData?.reason ? (
                    <p
                      className="text-red-500 bg-red-200 border-red-500 p-2 text-xl font-bold"
                      role="alert"
                    >
                      {actionData.reason}
                    </p>
                  ) : null}
                </div>

                <label htmlFor="email">Email address</label>
                <input
                  id="email"
                  required
                  name="email"
                  type="email"
                  autoComplete="email"
                  onKeyDown={() => setShowError(false)}
                  className="border border-gray-400 rounded px-2 py-1 mb-4"
                />

                <label htmlFor="password">Password</label>
                <input
                  id="password"
                  name="password"
                  type="password"
                  autoComplete="current-password"
                  onKeyDown={() => setShowError(false)}
                  className="border border-gray-400 rounded px-2 py-1 mb-4"
                />
                <ButtonBasic className="mt-4 !block text-center">
                  Log in
                </ButtonBasic>

                <div className="mt-4 text-center">
                  <a href={FORGOT_PASSWORD_URL}>Forgot password?</a>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
